import {PolicyAccount, PolicyIdentity} from './policy-account';

/**
 * Check if an account or any account within an identity has a specific role.
 */
export function hasRole(account: PolicyIdentity | PolicyAccount, roleKey: string): boolean {
  if ('accounts' in account) {
    return account.accounts.some(acc => hasSingleRole(acc, roleKey));
  }
  return hasSingleRole(account, roleKey);
}

function hasSingleRole(account: PolicyAccount, roleKey: string): boolean {
  return (account.roles ?? []).some(r => r.name === roleKey);
}
